<script>
  import UnblockUserButton from '@app-components/report/UnblockUserButton.svelte';
  import Icon from '@components/Icon.svelte';
  import { BlockedUserIconSvg } from '@utils/icons';
  export let user;
</script>

<style style="text/scss" lang="scss">
  @import '../../vendor/design-system.scss';

  .blocked-user {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #f1f1f1;
    border-radius: 8px;
    border: 1px solid #e3e3e3;
    padding: 58px 24px;

    margin: 0 auto;
    text-align: center;
    margin-top: 20px;

    .inner {
      max-width: 410px;
    }

    .icon {
      margin-bottom: 10px;
    }

    .message {
      margin-bottom: 20px;
      .title {
        @include typeface-h5($font-weight-regular);
        margin: 8px 0;
        color: $neutral-gray;

        strong {
          color: $neutral-black;
          font-weight: $font-weight-semi-bold;
        }
      }
    }

    .button-container {
      width: 90px;
      margin: 0 auto;
    }
  }
</style>

<div class="blocked-user">
  <div class="inner">
    <Icon size={26} style="margin-bottom: 10px" path={BlockedUserIconSvg} />
    <div class="message">
      <p class="title">
        You have blocked <strong>{user.name}</strong>. You need to unblock them to view their content.
      </p>
    </div>
    <div class="button-container">
      <UnblockUserButton user={user} />
    </div>
  </div>
</div>
